import { graphql } from "../../common/gql";

export const GET_PRODUCT_DETAIL = graphql(`
    query GetProductDetail($slug: String!, $reviewOptions: ProductReviewListOptions) {
        product(slug: $slug) {
            id
            optionGroups {
                id
                code
                name
                options {
                    id
                    name
                }
            }
            shippingRestrictions
            variants {
                id
                name
                featuredAsset {
                    ...Asset
                }
                assets {
                    ...Asset
                }
                options {
                    id
                    code
                    name
                    groupId
                }
                price
                priceWithTax
                sku
                stockLevel
                colorChartPosition
                customFields {
                    rrp
                    gtin
                }
                facetValues {
                    id
                    code
                }
                shippingInformation {
                    code
                    description
                }
            }
            featuredAsset {
                ...Asset
            }
            assets {
                ...Asset
            }
            collections {
                id
                slug
                name
                breadcrumbs {
                    id
                    name
                    slug
                }
                customFields {
                    isOfferCollection
                    offerName
                    offerDescription
                    displayRrpDiscount
                }
            }
            customFields {
                videoUrls
                variantOrdering
                reviewCount
                reviewRating
                seoTitle
                seoDescription
                seoImage {
                    id
                    preview
                }
                relatedBlogTags
            }
            reviews(options: $reviewOptions) {
                items {
                    ...ProductReview
                }
                totalItems
            }
            reviewsHistogram {
                bin
                frequency
            }
            facetValues {
                id
                name
                code
                facet {
                    id
                    code
                    name
                }
            }
        }
    }
`);

